import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/index.css';
import LoadStore from './components/LoadStore';

ReactDOM.render(<LoadStore />, document.getElementById('root'));